import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Card, ListGroup, Button, Modal } from "react-bootstrap";
import { Container, Row, Col, Image } from "react-bootstrap";
import { FaFacebook, FaTiktok, FaYoutube, FaInstagram, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import Footer from './footer';
import LatestUpdates from "./latestupdates";

import "./img.css";

const AAT = () => {
    return (

        <>
            <Container className="mt-5">
                <Row>
                    {/* Left Section - Image and Title */}


                    <Col md={8} className="d-flex flex-column align-items-center text-center">
                        <Image src="./img/AAT.jpg" alt="Professional Year" fluid />
                        <h2 className="mt-3">Administrative Review Tribunal (ART)</h2>
                        </Col>

                    {/* Right Section - Latest Posts and Social Media */}
                    <Col md={4}>
                        <Card>
                            <Card.Header className="fw-bold">Latest Posts</Card.Header>
                            <ListGroup variant="flush">
                                <ListGroup.Item><Link to="/professional" className="dropdown-item"> <a href="" className="text-decoration-none">Professional Year</a> </Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/coursechange" className="dropdown-item"> <a href="" className="text-decoration-none">Admissions And Course Change </a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/skilledID" className="dropdown-item"> <a href="" className="text-decoration-none">   Skilled Independent Visa (Subclass 189)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/workregionalvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Work Regional Visa (Subclass 491)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/nominatedvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Nominated Visa (Subclass 190)</a></Link></ListGroup.Item>
                                <ListGroup.Item><a href="https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/skilled-regional-191"
    className="dropdown-item text-decoration-none"
    style={{ color: "#22327f" }}
    target="_blank"
    rel="noopener noreferrer"
  >
    Permanent Residence visa (Subclass 191)
  </a>
</ListGroup.Item>



                                {/* <ListGroup.Item><Link to="/regionalvisa" className="dropdown-item"><a href="" className="text-decoration-none">Skilled Regional Visa (Subclass 887)</a></Link></ListGroup.Item> */
                                <ListGroup.Item><Link to="/tempactivity" className="dropdown-item"><a href="" className="text-decoration-none">Temporary Activity Visa (Subclass 408)</a></Link></ListGroup.Item>
}
                            </ListGroup>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <SecondSection />



            <LatestUpdates />
            <Footer />
        </>
    );

};







export default AAT;

const SecondSection = () => {
    return (
        <>
            <Container className="mt-4">

                {/* YouTube Embed Section */}
                <Row className="mt-3">
                    <Col md={8}>
                        <div className="ratio ratio-16x9">
                            <iframe
                                width="100%"
                                height="400"
                                src="https://www.youtube.com/embed/eTkrEJpG394"
                                title="YouTube video"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                            ></iframe>
                        </div><br />
                        <div>
  <p>
    The Administrative Review Tribunal (ART) provides independent review of administrative decisions made under Australian Commonwealth laws.
  </p>
  <p>
    If your visa or nomination has been refused or cancelled, you may be eligible to apply for a review through ART. At Bajwa Immigration Consultants, we are proud experts in handling ART applications. We assist you in preparing all necessary paperwork and guide you through the interview process so that you can feel 100% confident when answering questions during your ART hearing.
  </p>
  <p>
    We have successfully represented many clients and helped them win their cases. If you’re eligible, don’t delay get in touch with us today!
  </p>

  <h4 className="fw-bold mt-3">WHAT ARE THE CHANCES OF SUCCESS?</h4>
<p>
  To succeed in an <strong>ART appeal</strong>, the applicant must prove that the original decision involved an <strong>error of law</strong>, and that this error had a material effect on the outcome.
</p>

<p><strong>Common legal errors may include:</strong></p>
<ul>
  <li>Denying procedural fairness to the applicant</li>
  <li>Incorrect interpretation or application of immigration law</li>
</ul>

<p>
  However, even if an error of law is identified, the Judge may still dismiss the appeal if they determine that the original decision was clearly correct based on the available evidence.
</p>

<p><strong>Important to note:</strong></p>
<ul>
  <li>The Judge does <u>not</u> consider new evidence or facts not presented in the original decision (except in special cases)</li>
  <li>No new witnesses are called</li>
  <li>The Judge reviews the documents submitted in the original case</li>
  <li>Legal representatives from both parties present their arguments</li>
</ul>
</div>

                        <motion.button
                            initial={{ x: "-100vw", opacity: 0 }}
                            animate={{ x: 0, opacity: 1 }}
                            transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
                            className="btn btn-danger btn-sm position-fixed bottom-0 start-0 m-3"
                            style={{ zIndex: 1050 }}
                        >
                            <i className="bi bi-chat-left-text me-1"></i>
                            <a
                                href="https://au.bajwaimmigration.com/book-appointment"
                                className="text-white text-decoration-none"
                            >
                                Consult Now
                            </a>
                        </motion.button>
                    </Col>

                    {/* Right Side: Sidebar Section (Responsive) */}
<Col xs={12} md={3} className="sidebar-container">
    <Card className="p-3 text-center">
        {/* Bajwa Immigration Image */}
        <Image
            src="./img/brand-logo.png"
            alt="Bajwa Immigration Logo"
            fluid
            className="mb-3"
        />

        <h6 className="fw-bold">Subscribe to our YouTube channel</h6>
        <Button variant="danger" className="mb-3">
            <a href="https://www.youtube.com/channel/UCB2YzDKqwiv4IH4A6zoKKWw">SUBSCRIBE</a>
        </Button>

        <h6 className="fw-bold">Book Consultation</h6>
        <Button variant="warning">BOOK CONSULTATION</Button>

        <h6 className="fw-bold mt-3">Like Us on Facebook !!</h6>
        {/* Facebook Embed */}
        <iframe
            src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FBajwaImmigration&tabs&width=340&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
            width="100%"
            height="130"
            style={{ border: "none", overflow: "hidden" }}
            scrolling="no"
            frameBorder="0"
            allowFullScreen
        ></iframe>

        {/* Social Media */}
        <h6 className="fw-bold mt-3">We are also on:</h6>
        <div className="d-flex justify-content-center gap-3">
            <FaInstagram size={30} color="#C13584" />
            <FaTiktok size={30} color="#000" />
            <FaYoutube size={30} color="crimson" />
        </div>
    </Card>
</Col>

                </Row>
            </Container>

        </>
    );
};